import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "3.219",
  cy: "16.67",
  fill: "#198E59",
  rx: "1.219",
  ry: "1.217"
});
var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "11.946",
  cy: "13.557",
  fill: "#B3CFE5",
  rx: "1.219",
  ry: "1.217"
});
var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "5.159",
  cy: "19.783",
  fill: "#B3CFE5",
  rx: "1.219",
  ry: "1.217"
});
var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "6.128",
  cy: "13.557",
  fill: "#198E59",
  rx: "1.219",
  ry: "1.217"
});
var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "9.037",
  cy: "16.67",
  fill: "#198E59",
  rx: "1.219",
  ry: "1.217"
});
var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "14.855",
  cy: "10.443",
  fill: "#B3CFE5",
  rx: "1.219",
  ry: "1.217"
});
var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "14.855",
  cy: "13.557",
  fill: "#198E59",
  rx: "1.219",
  ry: "1.217"
});
var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "11.946",
  cy: "10.443",
  fill: "#B3CFE5",
  rx: "1.219",
  ry: "1.217"
});
var _ref0 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "17.764",
  cy: "10.443",
  fill: "#198E59",
  rx: "1.219",
  ry: "1.217"
});
var _ref1 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "20.673",
  cy: "7.33",
  fill: "#B3CFE5",
  rx: "1.219",
  ry: "1.217"
});
var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "14.855",
  cy: "7.33",
  fill: "#B3CFE5",
  rx: "1.219",
  ry: "1.217"
});
var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: "20.673",
  cy: "4.217",
  fill: "#198E59",
  rx: "1.219",
  ry: "1.217"
});
function ScatterPlotChartColor(_ref) {
  let {
    color = colors.actionMinor[500],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref2, _ref3, /*#__PURE__*/React.createElement("ellipse", {
    cx: "9.037",
    cy: "13.557",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("ellipse", {
    cx: "11.946",
    cy: "16.67",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "6.128",
    cy: "16.67",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), _ref7, /*#__PURE__*/React.createElement("ellipse", {
    cx: "20.78",
    cy: "10.443",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "17.764",
    cy: "7.33",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), _ref8, _ref9, _ref0, _ref1, _ref10, /*#__PURE__*/React.createElement("ellipse", {
    cx: "17.764",
    cy: "13.557",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "11.946",
    cy: "7.33",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "14.855",
    cy: "4.217",
    fill: color,
    rx: "1.219",
    ry: "1.217"
  }), _ref11);
}
export default ScatterPlotChartColor;